module.exports = __webpack_public_path__ + "static/media/b&o_poster_052123.d466ae8d.png";